import React from "react";

type HeaderButtonProps = {
  icon?: string | React.ReactNode;
  handleClick: () => void;
  className: string;
  buttonRef: any;
  dropdownOpen: boolean;
  children?: React.ReactNode;
};

export const HeaderButton = (props: HeaderButtonProps) => {
  return (
    <>
      <button
        ref={props.buttonRef}
        onClick={props.handleClick}
        type="button"
        className={props.className}
        aria-label={props.labelText}
      >
        <span>{props.icon}</span>
      </button>
      {props.dropdownOpen ? props.children : null}
    </>
  );
};
